import React, { FC } from "react";
import { Typography, Button, Pagination } from "antd";
import { VpdList } from "../../vpd-list";
import {
  ClientValue,
  Template,
  NewClientValue,
  ClientFilterData,
  MatterModalTemplateSearch,
} from "../../../data-types";
import { ClientAutoComplete } from "../../client-auto-complete";
import { TemplateTitleSearch } from "./template-title-search";

import styles from "../tabs.css";
import { useTaxonomyLabel } from "~/context/taxonomy-context";

const {
  ["tab-content"]: tabContentClassName,
  ["template-list"]: templateListClassName,
  ["practice-area-select"]: practiceAreaSelectClassName,
  ["pagination-container"]: paginationContainerClassName,
} = styles;

type Props = {
  items: Template[];
  onSelect: (template: Template) => void;
  loading?: boolean;
  onChangeClient: (client: ClientValue) => void;
  onClientSave: (details: NewClientValue) => void;
  clientFilterData: ClientFilterData;
  defaultClientValue?: ClientValue;
  templateSearch: MatterModalTemplateSearch;
  pagination: {
    current: number;
    total: number;
    onChange: (page: number, pageSize: number) => void;
    defaultPageSize?: number;
  };
};

export const ClientTemplateTab: FC<Props> = ({
  items,
  onSelect,
  loading,
  onChangeClient,
  onClientSave,
  clientFilterData,
  defaultClientValue,
  templateSearch,
  pagination,
}) => {
  const taxonomy = useTaxonomyLabel();
  return (
    <div className={tabContentClassName}>
      <ClientAutoComplete
        onClientSave={onClientSave}
        onChangeClient={(client) => onChangeClient(client)}
        clientFilterData={clientFilterData}
        bordered
        classname={practiceAreaSelectClassName}
        defaultValue={defaultClientValue}
      />
      <TemplateTitleSearch
        templateSearch={templateSearch}
        placeholder={`Enter part of ${taxonomy.Template} name to search`}
      />
      <VpdList
        itemKeyProperty="id"
        itemTextProperty="text"
        items={items}
        bordered={false}
        loading={loading}
        labels={{
          emptyText: "No items found",
        }}
        listStyle="primary"
        renderItem={(item) => (
          <VpdList.Item
            key={item.id}
            content={<Typography.Text>{item.title}</Typography.Text>}
            contentSuffix={<Button onClick={() => onSelect(item)}>Select</Button>}
          />
        )}
        className={templateListClassName}
      />
      <div className={paginationContainerClassName}>
        <Pagination
          current={pagination.current}
          onChange={pagination.onChange}
          total={pagination.total}
          defaultPageSize={pagination.defaultPageSize}
        />
      </div>
    </div>
  );
};
